module.exports = __webpack_public_path__ + "static/media/tc-experiences-logo.65ff1915.png";